import { useTranslation } from "react-i18next"

export const getDirFromLanguage = (language: string) => (language === "he" ? "rtl" : "ltr")

export const useDir = () => {
    const { i18n } = useTranslation()
    return getDirFromLanguage(i18n.language)
}
